module.exports = "<input class=\"form-control font-grey\" type=\"text\" name=\"dp\" [attr.disabled]=\"disabled\" [formControl]=\"parentFormControl\" [minDate]=\"minDate\"\r\n       [maxDate]=\"maxDate\" ngbDatepicker #d=\"ngbDatepicker\" (click)=\"d.toggle()\" autocomplete=\"off\" [placeholder]=\"placeholder\">\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/date-picker/date-picker.component.html
// module id = ./src/app/shared/components/date-picker/date-picker.component.html
// module chunks = main